import mapboxgl from 'mapbox-gl';
import { bbox } from '@turf/bbox';

import { createMap, renderSubways } from '../utils/map';

const LandlordBuildingsMapHook = {
  mounted() {
    const el = this.el.querySelector('[data-map]');

    this.map = createMap(el, -73.932803, 40.702891, { zoom: 12, scrollZoom: false });

    this.map.on('load', () => {
      renderSubways(this.map);

      this.map.addSource('buildings', {
        type: 'geojson',
        data: { type: 'FeatureCollection', features: [] },
      });

      this.map.addLayer({
        id: 'buildings',
        type: 'circle',
        source: 'buildings',
        paint: {
          'circle-color': '#165671',
          'circle-opacity': 0.1,
          'circle-radius': 10,
          'circle-stroke-width': 1,
          'circle-stroke-color': '#06171E',
        },
      });

      this.map.on('click', 'buildings', (e) => {
        const coordinates = e.features[0].geometry.coordinates.slice();
        const address = e.features[0].properties.address;

        // Ensure that if the map is zoomed out such that multiple
        // copies of the feature are visible, the popup appears
        // over the copy being pointed to.
        if (['mercator', 'equirectangular'].includes(this.map.getProjection().name)) {
          while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
          }
        }

        new mapboxgl.Popup().setLngLat(coordinates).setHTML(address).addTo(this.map);
      });

      this.renderMarkers();
    });
  },

  updated() {
    this.renderMarkers();
  },

  renderMarkers() {
    const buildingsSource = this.map.getSource('buildings');
    if (!buildingsSource) return;

    const data = JSON.parse(this.el.dataset.buildings);
    buildingsSource.setData(data);

    const buildingsBox = bbox(data);
    this.map.fitBounds(buildingsBox, {
      padding: 50,
      maxZoom: 13,
    });
  },
};

export default LandlordBuildingsMapHook;
